import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import styles from './styles.module.scss';
import JobCard from "@/components/JobCard";
import Button from "@/components/Button";
import Title from "@/ui/Title";

SwiperCore.use([Navigation, Autoplay]);

export default function LatestJobs({
  jobs,
  title,
  variant,
  internal=true,
  specialism=null
}) {

  if (specialism) {
    jobs = jobs.filter(job => {
      return job.categories.some(category => category.name === "Specialisms" ? category.values.some(discpline => discpline?.id === specialism) : false);
    });
  }
  else if (internal) {
    jobs = jobs.filter(job => {
      return job.categories.some(category => category.name === "Internal Jobs");
    });
  }

  let maxItems = 4;
  if(jobs.length < 4) {
    maxItems = jobs.length;
  }
  jobs = jobs.slice(0, maxItems);

  const breakpoints = {
    500: {
      slidesPerView: 1,
    },
    760: {
      slidesPerView: 2,
    },
    1150: {
      slidesPerView: 3,
    },
    1240: {
      slidesPerView: 4
    }
  };

  return (
    <div>
    <section id="LatestJobs" className={`${styles.LatestJobs}`}>
          <div className={styles.title_header}>
            <Title title={ `Latest ${title} Jobs`} tag="h3" highlight={false} variant={variant ?? "primary"} className={`h2 ${variant ?? "primary"} text-center`} />
          </div>
          <div className={styles.carousel}>
            {/* <div className={styles.arrow}>
              <img className={cn(styles.arrow_left, 'swiper-job-button-prev')} src="/icons/arrow-left.png"></img>
            </div> */}
            <div className={styles.wrapper}>
              <Swiper
                loop
                effect={"slide"}
                speed={5000}
                spaceBetween={10}
                // navigation={{ prevEl: '.swiper-job-button-prev', nextEl: '.swiper-job-button-next' }} 
                breakpoints={breakpoints}
                autoplay={{
                  delay: 1,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                  stopOnLastSlide: false,
                }}
              >
                {jobs?.map((job, index) => (
                  <SwiperSlide key={index}>
                    <JobCard
                      job={job}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
            {/* <div className={styles.arrow}>
              <img className={cn(styles.arrow_right, 'swiper-job-button-next')} src="/icons/arrow-right.svg"></img>
            </div> */}
          </div>
          <div className={styles.more_jobs_btn}>
            <Button display="View All Jobs" link="/jobs"></Button>
          </div>
    </section>
  </div>
  )
}


